import styles from './spinner.module.css';

export interface SpinnerProps {
  size?: 'sm' | 'md';
  label?: string;
  layout?: 'inline' | 'centered' | 'fullscreen';
  className?: string;
}

export function Spinner({
  size = 'md',
  label,
  layout = 'inline',
  className,
}: SpinnerProps) {
  const spinner = (
    <span
      className={`${styles.spinner} ${size === 'sm' ? styles.sm : styles.md}`}
      aria-hidden
    />
  );

  if (layout === 'fullscreen') {
    return (
      <div
        className={`${styles.fullScreen} ${className ?? ''}`}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        {spinner}
        {label && <span className={styles.label}>{label}</span>}
      </div>
    );
  }

  if (layout === 'centered') {
    return (
      <div
        className={`${styles.centered} ${className ?? ''}`}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        {spinner}
        {label && <span className={styles.label}>{label}</span>}
      </div>
    );
  }

  return (
    <span
      className={`${styles.inline} ${className ?? ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      {spinner}
      {label && <span className={styles.label}>{label}</span>}
    </span>
  );
}
